import { useIntl } from 'react-intl'
import { useRecoilCallback, useRecoilValue } from 'recoil'

import {
  Button,
  BUTTON_VARIANT_PRIMARY,
  BUTTON_VARIANT_SECONDARY,
  Flex,
  FlexItem
} from 'mailup-web-components'

import { useHistory } from 'react-router-dom'
import { saveCallback } from '../recoil/callbacks/callbacks'
import {
  contentsState,
  isSaveBtnDisabled,
  sourceState
} from '../recoil/state/source'

const Footer = () => {
  const intl = useIntl()
  const history = useHistory()
  const { idSource, idType } = useRecoilValue(sourceState)
  const { totalItems: totalContents } = useRecoilValue(contentsState)
  const saveDisabled = useRecoilValue(isSaveBtnDisabled)
  const otherDisabled = totalContents === 0

  const onClickSave = useRecoilCallback(saveCallback, [])

  const onClickSeeContents = () => {
    history.push(`/automation/source/viewContents/${idType}/${idSource}`)
  }

  return (
    <Flex justifyContent='flex-end' columnGap='8px'>
      <Button
        kind={BUTTON_VARIANT_SECONDARY}
        onClick={onClickSeeContents}
        disabled={otherDisabled}
        data-mu-test='button-see-contents'
      >
        {intl.formatMessage({ id: 'Load.ContentsSources.ViewContents' })}
      </Button>
      <FlexItem>
        <Button
          kind={BUTTON_VARIANT_PRIMARY}
          onClick={onClickSave}
          disabled={saveDisabled}
          data-mu-test='button-save'
        >
          {intl.formatMessage({ id: 'Load.MailupCommon.Save' })}
        </Button>
      </FlexItem>
    </Flex>
  )
}

export default Footer
